export enum EnumIndFinal {
    NORMAL = 0,
    CONSUMIDOR_FINAL = 1
}